import React from "react";
import { FileWarning } from "lucide-react";

/* Dir 176 — INTAKE red flag: the solicitation references stamped drawings, an equipment schedule, or numbered
   specification sections that were NOT in the attachment pull. The estimator must see this before the pricing
   engine runs — those documents carry the takeoff quantities and equipment ratings, so pricing is incomplete
   without them. Grounded: only rendered when `shred.missing_drawings_specs` has document-cited entries. */
export function MissingDrawingsSpecsBanner({ items, className = "" }) {
  if (!items || items.length === 0) return null;
  return (
    <div
      data-testid="missing-drawings-specs-banner"
      className={`rounded-lg border border-red-300 bg-red-50 p-3 ${className}`}
    >
      <div className="flex items-start gap-2">
        <FileWarning className="h-4 w-4 text-red-600 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <div className="text-sm font-semibold text-red-800" data-testid="missing-drawings-specs-text">
            Referenced drawings/specs not on file — pricing will be incomplete.
          </div>
          <ul className="mt-1.5 space-y-1">
            {items.map((it, i) => (
              <li
                key={i}
                className="text-[11px] text-red-700"
                data-testid={`missing-ds-item-${it.type || i}`}
              >
                <span className="font-medium">{it.label || it.type}</span> referenced
                {it.cited_in ? <span className="text-red-500"> in {it.cited_in}</span> : null}
                {it.evidence ? (
                  <span className="block text-red-500/90 italic mt-0.5 truncate">“…{it.evidence}…”</span>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
